import React, { useContext, useEffect } from "react";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AuthContext from "../../context/auth/authContext";
import Spots from "../spots/Spots";

const Spot = () => {
  const authContext = useContext(AuthContext);
  const { loadUser } = authContext;

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ width: '100%', pt: 8 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Local Finds
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Hidden gems and popular spots reviewed by fellow travelers.
        </Typography>
      </Box>
      <Spots />
    </Box>
  );
};

export default Spot;
